import { DxgLoadPanel } from '@lmt/unicorn-shared/app/components/common/dataGrid/DataGrid';
import { ScrollToTop } from '@lmt/unicorn-shared/app/components/common/table/helper';
import { triggerDownloadFileDialog } from '@lmt/unicorn-shared/app/helpers/file-helper';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ExportingEvent } from 'devextreme/ui/data_grid';
import { useCallback } from 'react';
import exceljs from 'exceljs';

export function ScrollTableOnScreenToTop(className?: string) {
  const tableContainerRoots = document.querySelectorAll<HTMLDivElement>(
    `[class*='${className ?? 'table-container-root'}']`,
  );
  for (const tableContainerRoot of tableContainerRoots) {
    //offsetParent is fine in our case because it is null for hidden tabs (because of 'display: none')
    if (
      tableContainerRoot.offsetParent !== null &&
      tableContainerRoot.firstElementChild
    ) {
      ScrollToTop(tableContainerRoot.firstElementChild);
    }
  }
}

export function useDataGridExportHandler(props: { fileName: string }) {
  const callback = useCallback(
    (event: ExportingEvent) => {
      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');

      exportDataGrid({
        component: event.component,
        worksheet,
        autoFilterEnabled: true,
        loadPanel: DxgLoadPanel,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          triggerDownloadFileDialog(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `${props.fileName}.xlsx`,
          );
        });
      });
    },
    [props.fileName],
  );

  return callback;
}
